<script>
export default {
  props: {
    action: {
      type: String,
      required: false,
      default: null,
    },

    status: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<template>
  <div
    class="checkout-callback"
  >
    <div
      class="checkout-callback__wrapper"
    >
      <div
        v-if="action"
        v-html="action"
      />

      <span
        v-else
        class="checkout-callback__message"
      >
        <span
          v-if="status === 'pending'"
          v-text="__('Você será redirecionado para a página de pagamentos')"
        />

        <span
          v-else
          v-text="__('Pagamento Aprovado!')"
        />
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../../sass/variables';

  .checkout-callback {
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    font-family: "BlinkMacSystemFont", "Popins", sans-serif;

    &__wrapper {
      width: 100%;
      padding: 48px;
      display: flex;
      max-width: 400px;
      align-items: center;
      border-radius: 8px;
      box-sizing: border-box;
      word-break: break-word;
      justify-content: center;
      flex-flow: column nowrap;
      background-color: $white;
    }

    &__message {
      font-size: 13px;
      font-weight: 500;
      line-height: 1.3;
      margin-bottom: 4px;
      color: rgba(26,26,26,.7);
    }
  }
</style>
